export const reportRoutes = [
  {
    path: '/reports',
    name: 'reports',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "Reports" */ './Reports.vue')
  }
];
